/*
  KP: "Complete the look" on product pages, in our own look. Replaces the Selleasy app's
  "Complete the look" box on every product type.

  It shows the product's complementary products (set in the Search & Discovery app) as a
  row of cards that is swiped sideways, in the same look as the "Add accessories" panel.
  Each card has the photo, the name (a link to that product), the price, a dropdown when
  the product comes in more than one kind, and an "+ Add" button that puts it in the cart
  at its normal price.

  Where it sits:
    - every product type: exactly where the Selleasy box is in the page (it is put right
      in front of Selleasy's block, which is then hidden). If a page has no Selleasy
      "Complete the look" block, nothing is shown there.
    - phone cases (products with a Model and a Case Type option) on larger screens only:
      under the photo gallery in the left column instead, four cards across.
  The Selleasy box is hidden, not removed, and only while ours is showing. Names, photos,
  prices and options are read from the store when the page opens. If the product has no
  complementary products, nothing is shown and the Selleasy box is left alone.

  The look is in the style rules at the bottom of this file.
  Loaded by snippets/theme-globals.liquid. Delete that line to go back to Selleasy's box.
*/
(function () {
  var API = '/api/2025-07/graphql.json';
  var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;
  var TITLE = 'Complete the look';
  var ADD_LABEL = '+ Add';
  var ADDED_LABEL = '\u2713 Added';
  var FAILED_LABEL = 'Try again';
  // Selleasy's "Complete the look" app block.
  var OLD = '.shopify-app-block.lb-widget-cpac';
  var FIELDS = ' { handle title featuredImage { url(transform: { maxWidth: 400 }) } variants(first: 250) { nodes { id title availableForSale price { amount } compareAtPrice { amount } image { url(transform: { maxWidth: 400 }) } } } }';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function withSeparators(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function money(amount) {
    var format = window.theme && window.theme.moneyFormat;
    var value = parseFloat(amount);

    if (!format || isNaN(value) || !MONEY_TOKEN.test(format)) return '';

    return format.replace(MONEY_TOKEN, function (match, type) {
      switch (type) {
        case 'amount_no_decimals':
          return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(value, 0, '.', ',');
        default:
          return withSeparators(value, 2, ',', '.');
      }
    });
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function numberOf(variant) {
    return variant.id.split('/').pop();
  }

  function load(handle) {
    var query = 'query ($h: String!, $c: CountryCode) @inContext(country: $c) { recs: productRecommendations(productHandle: $h, intent: COMPLEMENTARY)' + FIELDS + ' }';

    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: { h: handle, c: (window.Shopify && window.Shopify.country) || null } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        return (json && json.data && json.data.recs) || [];
      })
      .catch(function () {
        return [];
      });
  }

  // Show the price and photo of the kind chosen in a card.
  function paint(card) {
    var product = card.kpProduct;
    var select = card.querySelector('[data-kp-look-variant]');
    var variant = card.kpVariants.filter(function (v) {
      return numberOf(v) === select.value;
    })[0];
    if (!variant) return;

    var onSale = variant.compareAtPrice && parseFloat(variant.compareAtPrice.amount) > parseFloat(variant.price.amount);
    card.querySelector('.kp-look__price').innerHTML = (onSale ? '<s>' + money(variant.compareAtPrice.amount) + '</s> ' : '') + money(variant.price.amount);

    var image = card.querySelector('.kp-look__image');
    var src = (variant.image && variant.image.url) || (product.featuredImage && product.featuredImage.url) || '';
    if (src && image.getAttribute('src') !== src) image.setAttribute('src', src);
  }

  function buildCard(product) {
    var variants = product.variants.nodes.filter(function (variant) {
      return variant.availableForSale;
    });
    if (!variants.length) return null;

    var card = el('div', 'kp-look__card');
    card.kpProduct = product;
    card.kpVariants = variants;

    var link = el('a', 'kp-look__photo');
    link.href = rootUrl() + 'products/' + product.handle;
    link.setAttribute('aria-label', product.title);
    var image = el('img', 'kp-look__image');
    image.alt = '';
    image.loading = 'lazy';
    image.width = 200;
    image.height = 200;
    link.appendChild(image);
    card.appendChild(link);

    var name = el('a', 'kp-look__name', product.title);
    name.href = link.href;
    card.appendChild(name);
    card.appendChild(el('div', 'kp-look__price'));

    var actions = el('div', 'kp-look__actions');

    var select = el('select', 'kp-look__select');
    select.setAttribute('data-kp-look-variant', '');
    select.setAttribute('aria-label', product.title);
    variants.forEach(function (variant) {
      var option = el('option', '', variant.title);
      option.value = numberOf(variant);
      select.appendChild(option);
    });
    if (variants.length < 2) select.hidden = true;
    actions.appendChild(select);

    var button = el('button', 'kp-look__add', ADD_LABEL);
    button.type = 'button';
    button.setAttribute('data-kp-look-add', '');
    button.setAttribute('aria-label', 'Add ' + product.title + ' to cart');
    actions.appendChild(button);

    card.appendChild(actions);
    paint(card);

    return card;
  }

  // Tell the rest of the page the cart has changed: the header count
  // (assets/kp-cart-sync.js) and the Rebuy cart.
  function announce() {
    try {
      document.dispatchEvent(new CustomEvent('kp:cart.change'));
    } catch (e) {}

    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart();
    } catch (e) {}
  }

  function add(card, button) {
    var select = card.querySelector('[data-kp-look-variant]');
    if (button.disabled || !select || !select.value) return;

    button.disabled = true;

    var done = function (ok) {
      button.textContent = ok ? ADDED_LABEL : FAILED_LABEL;
      button.classList.toggle('is-added', ok);
      if (ok) announce();

      window.setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = ADD_LABEL;
      }, ok ? 1800 : 1500);
    };

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(select.value, 10), quantity: 1 }] })
    }).then(function (response) {
      done(response.ok);
    }, function () {
      done(false);
    });
  }

  function start(blocks) {
    if (blocks.kpLook) return;

    var form = blocks.querySelector('form[data-product-form]');
    if (!form) return;

    var handle = form.getAttribute('data-product-handle');
    if (!handle) return;

    var product = blocks.closest('.product');
    var scope = product || blocks;

    // Phone cases: a Model and a Case Type option. They may go under the gallery.
    var wrapper = blocks.querySelector('.product__variants-wrapper');
    var isCase = !!wrapper && !!wrapper.querySelector('select[name="options[Model]"]') && !!wrapper.querySelector('select[name="options[Case Type]"]');

    // Other products go exactly where the Selleasy box is; no Selleasy box, nothing to do.
    if (!isCase && !scope.querySelector(OLD)) return;
    blocks.kpLook = true;

    load(handle).then(function (products) {
      var panel = el('div', 'kp-look');
      panel.appendChild(el('div', 'kp-look__title', TITLE));

      var track = el('div', 'kp-look__track');
      var count = 0;
      products.forEach(function (item) {
        var card = buildCard(item);
        if (!card) return;
        track.appendChild(card);
        count++;
      });
      if (!count) return;

      panel.appendChild(track);

      var dots = el('div', 'kp-look__dots');
      dots.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < count; i++) dots.appendChild(el('span'));
      panel.appendChild(dots);

      function place() {
        var gallery = isCase && product ? product.querySelector('.product__media-container.above-mobile') : null;
        var wide = !!gallery && window.getComputedStyle(gallery).display !== 'none';

        if (wide) {
          // Phone cases on larger screens: under the photo gallery.
          if (!(panel.parentNode === gallery.parentNode && panel.previousElementSibling === gallery)) {
            gallery.parentNode.insertBefore(panel, gallery.nextSibling);
          }
        } else {
          // Everything else: right in front of the Selleasy box, wherever that is.
          var old = scope.querySelector(OLD);
          if (old) {
            if (!(panel.parentNode === old.parentNode && panel.nextElementSibling === old)) old.parentNode.insertBefore(panel, old);
          } else if (panel.parentNode !== blocks) {
            blocks.appendChild(panel);
          }
        }

        if (panel.classList.contains('kp-look--wide') !== wide) panel.classList.toggle('kp-look--wide', wide);

        // In a column with room for it (larger screens), three cards across.
        var roomy = !wide && panel.clientWidth >= 520;
        if (panel.classList.contains('kp-look--roomy') !== roomy) panel.classList.toggle('kp-look--roomy', roomy);

        mark();
      }

      // Dots only when the row is wider than its box; the current card's dot is the pill.
      function mark() {
        var scrolls = track.scrollWidth > track.clientWidth + 4;
        if (dots.hidden === scrolls) dots.hidden = !scrolls;
        if (!scrolls) return;

        var current = 0;
        var nearest = Infinity;
        each(track.children, function (card, n) {
          var gap = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (gap < nearest) {
            nearest = gap;
            current = n;
          }
        });

        // At the very end of the row the last card can never reach the left edge.
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) current = track.children.length - 1;

        each(dots.children, function (dot, n) {
          var active = n === current;
          if (dot.classList.contains('is-active') !== active) dot.classList.toggle('is-active', active);
        });
      }

      panel.addEventListener('change', function (event) {
        var card = event.target.closest ? event.target.closest('.kp-look__card') : null;
        if (card && event.target.matches('[data-kp-look-variant]')) paint(card);
      });

      panel.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-kp-look-add]') : null;
        if (button) add(button.closest('.kp-look__card'), button);
      });

      var waiting = false;
      track.addEventListener('scroll', function () {
        if (waiting) return;
        waiting = true;
        window.setTimeout(function () {
          waiting = false;
          mark();
        }, 60);
      }, { passive: true });

      window.addEventListener('resize', place);

      // The theme re-draws the gallery when the variant changes; keep our place under it.
      if (window.MutationObserver && product) {
        var left = product.querySelector('.product__primary-left');
        if (left) new MutationObserver(place).observe(left, { childList: true });
      }

      place();
      // The style rules hide the Selleasy box while this mark is on.
      scope.classList.add('kp-look-on');
    });
  }

  function initAll() {
    each(document.querySelectorAll('.product-blocks'), start);
  }

  var ARROW = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M1.5 1.5 6 6l4.5-4.5' stroke='%23111' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";

  var style = document.createElement('style');
  style.textContent = [
    // Selleasy's own box steps aside while ours is showing.
    '.kp-look-on .shopify-app-block.lb-widget-cpac{display:none !important}',
    '.kp-look [hidden]{display:none !important}',
    // The grey band and its title: the same as the "Add accessories" panel.
    '.kp-look{margin:20px 0;padding:16px 12px;background:#f3f3f3}',
    '.kp-look__title{margin:0 0 12px;color:#111;font-size:14px;font-weight:600;letter-spacing:.02em;line-height:1.2;text-align:center;text-transform:uppercase}',
    // The row of cards, swiped sideways.
    '.kp-look__track{display:flex;gap:10px;overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch}',
    '.kp-look__track::-webkit-scrollbar{display:none}',
    '.kp-look__card{display:flex;flex:0 0 62%;flex-direction:column;box-sizing:border-box;min-width:0;padding:10px;overflow:hidden;border:1px solid #dcdcdc;border-radius:6px;background:#fff;scroll-snap-align:start}',
    // Under the gallery on larger screens (phone cases): four cards across.
    '.kp-look--wide .kp-look__card{flex-basis:calc((100% - 30px) / 4)}',
    // In a column with room for it: three cards across.
    '.kp-look--roomy .kp-look__card{flex-basis:calc((100% - 20px) / 3)}',
    '.kp-look__photo{display:block}',
    '.kp-look__image{display:block;width:100%;height:auto;aspect-ratio:1 / 1;object-fit:contain;background:#fff}',
    '.kp-look__name{display:block;margin-top:8px;color:#111;font-size:13px;font-weight:600;line-height:1.3;text-decoration:none}',
    '.kp-look__price{margin-top:4px;color:#111;font-size:13px;font-weight:600;line-height:1.3}',
    '.kp-look__price s{color:#8a8a8a;font-weight:400}',
    '.kp-look__actions{margin-top:auto;padding-top:8px;overflow:hidden}',
    // Dropdown: 13px text like the model dropdown.
    '.kp-look .kp-look__select{display:block;width:100%;max-width:none;height:36px;min-height:0;margin:0;padding:0 30px 0 10px;border:1px solid #ccc;border-radius:6px;background-color:#fff;background-image:' + ARROW + ';background-repeat:no-repeat;background-position:right 10px center;background-size:12px 8px;box-shadow:none;color:#111;font-family:inherit;font-size:13px;line-height:34px;text-overflow:ellipsis;cursor:pointer;-webkit-appearance:none;appearance:none}',
    // Phones: the theme keeps dropdowns at 16px text; draw it at 81.25% (13px), as in the accessories panel.
    '@media (max-width:719px){.kp-look .kp-look__select{width:123.08%;height:44.3px;margin-bottom:-8.3px;padding:0 37px 0 12px;border-width:1.25px;border-radius:7.4px;background-position:right 12px center;background-size:14.8px 9.8px;font-size:16px;line-height:42px;transform:scale(.8125);transform-origin:0 0}}',
    // "+ Add": the same button as the accessories panel.
    '.kp-look .kp-look__add{display:block;width:100%;height:36px;min-height:0;margin:8px 0 0;padding:0 14px;border:1.5px solid #111;border-radius:6px;background:#fff;box-shadow:none;color:#111;font-family:inherit;font-size:13px;font-weight:700;letter-spacing:.02em;line-height:1;text-transform:uppercase;white-space:nowrap;cursor:pointer;transition:background-color .15s ease,color .15s ease,transform .1s ease;-webkit-appearance:none;appearance:none}',
    '.kp-look .kp-look__select[hidden] + .kp-look__add{margin-top:0}',
    '.kp-look .kp-look__add:active{transform:scale(.97)}',
    '.kp-look .kp-look__add[disabled]{cursor:default}',
    '.kp-look .kp-look__add.is-added{background:#111;color:#fff}',
    // Dots: the same as on the main photo.
    '.kp-look__dots{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:12px}',
    '.kp-look__dots span{display:block;width:6px;height:6px;border-radius:3px;background:rgba(0,0,0,.22);transition:width .2s ease,background-color .2s ease}',
    '.kp-look__dots span.is-active{width:20px;background:#111}'
  ].join('');
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
